module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.3/frontend/_next/static/images/rectangle-4-1a3ce59eec0bb5b04a76be2a9b6f6140.png";